import { render, staticRenderFns } from "./SortGroupListElement.vue?vue&type=template&id=31c9ab72"
import script from "./SortGroupListElement.vue?vue&type=script&lang=ts"
export * from "./SortGroupListElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports